export const DARK_BLUE = '#001936';
export const LIGHT_PURPLE = '#E7DDF9';
export const CREAM = '#EFEDEC';
export const EVERGREEN = '#003F48';
export const BRIGHT_LAVENDER = '#764BFF';
export const MINT = '#A9FBBD';
export const GRAPEFRUIT = '#FF4412';
export const FOREST = '#079A63';
export const INK = '#000B1E';
export const INK_96 = 'rgba(0,11,30,0.96)';
export const INK_88 = 'rgba(0,11,30,0.88)';
export const INK_80 = 'rgba(0,11,30,0.8)';
export const INK_72 = 'rgba(0,11,30,0.72)';
export const INK_64 = 'rgba(0,11,30,0.64)';
export const INK_56 = 'rgba(0,11,30,0.56)';
export const INK_48 = 'rgba(0,11,30,0.48)';
export const INK_40 = 'rgba(0,11,30,0.4)';
export const INK_32 = 'rgba(0,11,30,0.32)';
export const INK_24 = 'rgba(0,11,30,0.24)';
export const INK_16 = 'rgba(0,11,30,0.16)';
export const INK_8 = 'rgba(0,11,30,0.08)';
export const SALT = '#FDFCFC';
export const SALT_96 = 'rgba(253,252,252,0.96)';
export const SALT_88 = 'rgba(253,252,252,0.88)';
export const SALT_80 = 'rgba(253,252,252,0.8)';
export const SALT_72 = 'rgba(253,252,252,0.72)';
export const SALT_64 = 'rgba(253,252,252,0.64)';
export const SALT_56 = 'rgba(253,252,252,0.56)';
export const SALT_48 = 'rgba(253,252,252,0.48)';
export const SALT_40 = 'rgba(253,252,252,0.4)';
export const SALT_32 = 'rgba(253,252,252,0.32)';
export const SALT_24 = 'rgba(253,252,252,0.24)';
export const SALT_16 = 'rgba(253,252,252,0.16)';
export const SALT_8 = 'rgba(253,252,252,0.08)';
export const MONO_0 = '#FFFFFF';
export const MONO_1 = '#F6F7F8';
export const MONO_2 = '#EEEFF2';
export const MONO_3 = '#E2E5E9';
export const MONO_4 = '#C6CCD4';
export const MONO_5 = '#AAB3BF';
export const MONO_6 = '#8F9BAA';
export const MONO_7 = '#657589';
export const MONO_8 = '#43576E';
export const MONO_9 = '#2B415B';
export const MONO_10 = '#001936';
export const MONO_11 = '#000B1E';
export const CREAM_1 = '#FDFCFC';
export const CREAM_2 = '#F6F5F4';
export const CREAM_3 = '#EFEDEC';
export const CREAM_4 = '#d0cecd';
export const PURPLE_1 = '#F8F2FE';
export const PURPLE_2 = '#F3ECFD';
export const PURPLE_3 = '#E7DDF9';
export const PURPLE_4 = '#CDB7FF';
export const PURPLE_5 = '#B293FF';
export const PURPLE_6 = '#9B78FF';
export const PURPLE_7 = '#764BFF';
export const PURPLE_8 = '#5A36DB';
export const PURPLE_9 = '#4125B7';
export const EVERGREEN_1 = '#EDF0F1';
export const EVERGREEN_2 = '#E5EAEB';
export const EVERGREEN_3 = '#CBD6D8';
export const EVERGREEN_4 = '#99AEB1';
export const EVERGREEN_5 = '#819A9F';
export const EVERGREEN_6 = '#51747B';
export const EVERGREEN_7 = '#3A6269';
export const EVERGREEN_8 = '#215058';
export const EVERGREEN_9 = '#003F48';
export const FOREST_1 = '#F0FEEE';
export const FOREST_2 = '#DEFEDD';
export const FOREST_3 = '#CCFDCE';
export const FOREST_4 = '#A9FBBD';
export const FOREST_5 = '#60E097';
export const FOREST_6 = '#37C280';
export const FOREST_7 = '#079A63';
export const FOREST_8 = '#058461';
export const FOREST_9 = '#036E5B';
export const LEMONADE_1 = '#FFFDE0';
export const LEMONADE_2 = '#FFFCCC';
export const LEMONADE_3 = '#FFF899';
export const LEMONADE_4 = '#FFF366';
export const LEMONADE_5 = '#FFEE3F';
export const LEMONADE_6 = '#FFE600';
export const LEMONADE_7 = '#DBC300';
export const LEMONADE_8 = '#B7A100';
export const LEMONADE_9 = '#7A6900';
export const GRAPEFRUITY_1 = '#FFEFDB';
export const GRAPEFRUITY_2 = '#FFE7CF';
export const GRAPEFRUITY_3 = '#FFC9A0';
export const GRAPEFRUITY_4 = '#FFA370';
export const GRAPEFRUITY_5 = '#FF7F4D';
export const GRAPEFRUITY_6 = '#FF4412';
export const GRAPEFRUITY_7 = '#DB290D';
export const GRAPEFRUITY_8 = '#B71409';
export const GRAPEFRUITY_9 = '#930507';
export const STRAWBERRY_1 = '#FFF3ED';
export const STRAWBERRY_2 = '#FFE5DD';
export const STRAWBERRY_3 = '#FFD8D2';
export const STRAWBERRY_4 = '#FFA9A5';
export const STRAWBERRY_5 = '#FF787F';
export const STRAWBERRY_6 = '#FF576F';
export const STRAWBERRY_7 = '#FF1F55';
export const STRAWBERRY_8 = '#DB1659';
export const STRAWBERRY_9 = '#B70F58';
export const TRANSPARENT = 'transparent';
